import { TableProps } from "antd";
import useIntl from "react-intl/lib/src/components/useIntl";
import { TableHeaderFilter } from "@lib/types/Api";
import { useMemo } from "react";
import AppsContent from "@lib/components/AppComponents/AppsContainer/AppsContent";
import AppsHeader from "@lib/components/AppComponents/AppsContainer/AppsHeader";
import AppTableContentHeader from "@lib/components/MiniComponents/Table/AppTableContentHeader";
import AppTable from "@lib/components/MiniComponents/Table/AppTable";
import { useParamsManager } from "@lib/hooks/useParamsManager";
import { handleTableChange } from "@lib/helpers/UrlHelper";
import getColumns from "./columns";
import { useNavigate } from "react-router-dom";
import { useTypedSelector } from "@lib/redux";
import { AuditLogActionTypeEnum } from "@lib/types/Monitoring";
import { useAuditLogQueries } from "@lib/apiQueries";
import { MyProfileTabProps } from "..";

const LoginHistory = (props: MyProfileTabProps) => {
  const { loading } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();
  const { user } = useTypedSelector((state) => state.auth);
  // const { query, updateQuery } = props;
  // const apiData = useMemo(() => query?.data?.data, [query?.data]);

  const { params, setParams, onPageChange, handleRemoveFilters } =
    useParamsManager({
      page: 1,
      limit: 100,
      sort: "createdAt,DESC",
      join: ["manager"],
      s: [
        {
          $and: [
            { managerId: { $eq: user.id } },
            { actionType: { $eq: AuditLogActionTypeEnum.Login } },
          ],
        },
      ],
    });

  const { auditLogsQuery } = useAuditLogQueries({
    params,
    messages,
    enabled: !!user?.id && !loading,
  });
  const { data, isLoading, isFetching } = auditLogsQuery;
  const apiData = data?.data?.data;

  const onChange: TableProps<any>["onChange"] = (
    pagination,
    filters,
    sorter,
  ) => {
    handleTableChange({ pagination, filters, sorter, params, setParams });
  };

  const columns = useMemo(
    () =>
      getColumns({
        apiData,
        params,
        messages,
        navigate,
      }),
    [apiData, params],
  );

  const filters = useMemo(() => {
    if (!params?.filter) return [];

    return params?.filter.map((f) => ({
      key: f.split("||")[0],
      title: columns.find((c) => c?.key === f.split("||")[0])?.title || "",
      operator: f.split("||")[1],
      value: f.split("||")[2],
    })) as TableHeaderFilter[];
  }, [params]);

  return (
    <>
      <AppsHeader>
        <AppTableContentHeader
          showInfo
          page={params?.page || 1}
          perPage={params?.limit || 10}
          onPageChange={onPageChange}
          query={auditLogsQuery}
          filters={filters}
          handleRemoveFilters={handleRemoveFilters}
        />
      </AppsHeader>
      <AppsContent>
        <AppTable
          dataSource={apiData}
          columns={columns}
          rowKey={"id"}
          loading={isLoading || isFetching || loading}
          onChange={onChange}
        />
      </AppsContent>
    </>
  );
};

export default LoginHistory;
